// extracted by mini-css-extract-plugin
module.exports = {"tokens":"formGuideRequest_tokens__6djk_","formGuideRequest":"formGuideRequest_formGuideRequest__10a1j","formGuideBlock":"formGuideRequest_formGuideBlock__yQ2mJ"};